import styled from 'styled-components'
import PropTypes from 'prop-types'
import { transparentize } from 'polished'
import { border, radius } from 'config/theme'
import { COLORS } from 'config/constants'
import { pxToRem } from 'utils/helpers'
import { space, height, fontSize, width, maxWidth } from 'styled-system'

const inputFuncs = [space, height, width, maxWidth, fontSize]

const Input = styled.input`
  height: ${pxToRem(56)};
  border-radius: ${radius.m};
  color: ${COLORS.LUXURY};
  font-size: 16px; /* needs to be at least 16px so iOS won't zoom into the input */
  display: block;
  background-color: ${({ isValid }) =>
    isValid ? `unset` : transparentize(0.85, COLORS.RED_ORANGE_JUICE)};
  :focus {
    border-color: ${COLORS.BUTTERSCOTCH};
    outline: none;
  }
  ::placeholder {
    color: ${COLORS.LUXURY};
    line-height: normal;
    font-size: 16px;
  }
  border: ${({ borderParams }) => borderParams || border};
  ${inputFuncs}
`

Input.propTypes = {
  isValid: PropTypes.bool,
  borderParams: PropTypes.string,
}

Input.defaultProps = {
  isValid: true,
}

export default Input
